/* tslint:disable */
/* eslint-disable */
/**
 * CipherMail back-end API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ExportSecretKeysRequestBody } from '../model';
// @ts-ignore
import type { GenerateSecretKeyRingDetails } from '../model';
// @ts-ignore
import type { PGPKeyDetails } from '../model';
// @ts-ignore
import type { PGPKeyGenerationType } from '../model';
/**
 * PGPApi - axios parameter creator
 * @export
 */
export const PGPApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pGPControllerExportPublicKeys: async (requestBody: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('pGPControllerExportPublicKeys', 'requestBody', requestBody)
            const localVarPath = `/api/pgp/exportPublicKeys`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ExportSecretKeysRequestBody} exportSecretKeysRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pGPControllerExportSecretKeys: async (exportSecretKeysRequestBody: ExportSecretKeysRequestBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'exportSecretKeysRequestBody' is not null or undefined
            assertParamExists('pGPControllerExportSecretKeys', 'exportSecretKeysRequestBody', exportSecretKeysRequestBody)
            const localVarPath = `/api/pgp/exportSecretKeys`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(exportSecretKeysRequestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} email 
         * @param {string} name 
         * @param {PGPKeyGenerationType} [keyType] 
         * @param {boolean} [publishKeys] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pGPControllerGenerateSecretKeyRing: async (email: string, name: string, keyType?: PGPKeyGenerationType, publishKeys?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'email' is not null or undefined
            assertParamExists('pGPControllerGenerateSecretKeyRing', 'email', email)
            // verify required parameter 'name' is not null or undefined
            assertParamExists('pGPControllerGenerateSecretKeyRing', 'name', name)
            const localVarPath = `/api/pgp/generateSecretKeyRing`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (keyType !== undefined) {
                localVarQueryParameter['keyType'] = keyType;
            }

            if (publishKeys !== undefined) {
                localVarQueryParameter['publishKeys'] = publishKeys;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} domain 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pGPControllerGetAvailableSigningKeysForDomain: async (domain: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'domain' is not null or undefined
            assertParamExists('pGPControllerGetAvailableSigningKeysForDomain', 'domain', domain)
            const localVarPath = `/api/pgp/getAvailableSigningKeysForDomain`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            if (domain !== undefined) {
                localVarQueryParameter['domain'] = domain;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pGPControllerGetAvailableSigningKeysForEmail: async (email: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'email' is not null or undefined
            assertParamExists('pGPControllerGetAvailableSigningKeysForEmail', 'email', email)
            const localVarPath = `/api/pgp/getAvailableSigningKeysForEmail`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} domain 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pGPControllerGetEncryptionKeysForDomain: async (domain: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'domain' is not null or undefined
            assertParamExists('pGPControllerGetEncryptionKeysForDomain', 'domain', domain)
            const localVarPath = `/api/pgp/getEncryptionKeysForDomain`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            if (domain !== undefined) {
                localVarQueryParameter['domain'] = domain;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pGPControllerGetEncryptionKeysForEmail: async (email: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'email' is not null or undefined
            assertParamExists('pGPControllerGetEncryptionKeysForEmail', 'email', email)
            const localVarPath = `/api/pgp/getEncryptionKeysForEmail`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} domain 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pGPControllerGetSigningKeyForDomain: async (domain: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'domain' is not null or undefined
            assertParamExists('pGPControllerGetSigningKeyForDomain', 'domain', domain)
            const localVarPath = `/api/pgp/getSigningKeyForDomain`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            if (domain !== undefined) {
                localVarQueryParameter['domain'] = domain;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pGPControllerGetSigningKeyForUser: async (email: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'email' is not null or undefined
            assertParamExists('pGPControllerGetSigningKeyForUser', 'email', email)
            const localVarPath = `/api/pgp/getSigningKeyForUser`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {boolean} [ignoreParsingErrors] 
         * @param {string} [password] 
         * @param {File} [keyringFile] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pGPControllerImportKeyring: async (ignoreParsingErrors?: boolean, password?: string, keyringFile?: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/pgp/importKeyring`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            if (ignoreParsingErrors !== undefined) {
                localVarQueryParameter['ignoreParsingErrors'] = ignoreParsingErrors;
            }


            if (password !== undefined) { 
                localVarFormParams.append('password', password as any);
            }
    
            if (keyringFile !== undefined) { 
                localVarFormParams.append('keyringFile', keyringFile as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {string} userID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pGPControllerIsUserIDRevoked: async (id: string, userID: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('pGPControllerIsUserIDRevoked', 'id', id)
            // verify required parameter 'userID' is not null or undefined
            assertParamExists('pGPControllerIsUserIDRevoked', 'userID', userID)
            const localVarPath = `/api/pgp/isUserIDRevoked`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }

            if (userID !== undefined) {
                localVarQueryParameter['userID'] = userID;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {string} userID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pGPControllerIsUserIDValid: async (id: string, userID: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('pGPControllerIsUserIDValid', 'id', id)
            // verify required parameter 'userID' is not null or undefined
            assertParamExists('pGPControllerIsUserIDValid', 'userID', userID)
            const localVarPath = `/api/pgp/isUserIDValid`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }

            if (userID !== undefined) {
                localVarQueryParameter['userID'] = userID;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pGPControllerRevokeKey: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('pGPControllerRevokeKey', 'id', id)
            const localVarPath = `/api/pgp/revokeKey`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pGPControllerRevokeKeys: async (requestBody: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('pGPControllerRevokeKeys', 'requestBody', requestBody)
            const localVarPath = `/api/pgp/revokeKeys`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pGPControllerSetPGPKeyEmailAndDomains: async (id: string, requestBody: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('pGPControllerSetPGPKeyEmailAndDomains', 'id', id)
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('pGPControllerSetPGPKeyEmailAndDomains', 'requestBody', requestBody)
            const localVarPath = `/api/pgp/setPGPKeyEmailAndDomains`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} domain 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pGPControllerSetSigningKeyForDomain: async (domain: string, id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'domain' is not null or undefined
            assertParamExists('pGPControllerSetSigningKeyForDomain', 'domain', domain)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('pGPControllerSetSigningKeyForDomain', 'id', id)
            const localVarPath = `/api/pgp/setSigningKeyForDomain`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            if (domain !== undefined) {
                localVarQueryParameter['domain'] = domain;
            }

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} email 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pGPControllerSetSigningKeyForUser: async (email: string, id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'email' is not null or undefined
            assertParamExists('pGPControllerSetSigningKeyForUser', 'email', email)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('pGPControllerSetSigningKeyForUser', 'id', id)
            const localVarPath = `/api/pgp/setSigningKeyForUser`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PGPApi - functional programming interface
 * @export
 */
export const PGPApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PGPApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pGPControllerExportPublicKeys(requestBody: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pGPControllerExportPublicKeys(requestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PGPApi.pGPControllerExportPublicKeys']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {ExportSecretKeysRequestBody} exportSecretKeysRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pGPControllerExportSecretKeys(exportSecretKeysRequestBody: ExportSecretKeysRequestBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pGPControllerExportSecretKeys(exportSecretKeysRequestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PGPApi.pGPControllerExportSecretKeys']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} email 
         * @param {string} name 
         * @param {PGPKeyGenerationType} [keyType] 
         * @param {boolean} [publishKeys] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pGPControllerGenerateSecretKeyRing(email: string, name: string, keyType?: PGPKeyGenerationType, publishKeys?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GenerateSecretKeyRingDetails>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pGPControllerGenerateSecretKeyRing(email, name, keyType, publishKeys, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PGPApi.pGPControllerGenerateSecretKeyRing']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} domain 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pGPControllerGetAvailableSigningKeysForDomain(domain: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PGPKeyDetails>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pGPControllerGetAvailableSigningKeysForDomain(domain, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PGPApi.pGPControllerGetAvailableSigningKeysForDomain']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pGPControllerGetAvailableSigningKeysForEmail(email: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PGPKeyDetails>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pGPControllerGetAvailableSigningKeysForEmail(email, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PGPApi.pGPControllerGetAvailableSigningKeysForEmail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} domain 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pGPControllerGetEncryptionKeysForDomain(domain: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PGPKeyDetails>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pGPControllerGetEncryptionKeysForDomain(domain, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PGPApi.pGPControllerGetEncryptionKeysForDomain']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pGPControllerGetEncryptionKeysForEmail(email: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PGPKeyDetails>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pGPControllerGetEncryptionKeysForEmail(email, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PGPApi.pGPControllerGetEncryptionKeysForEmail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} domain 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pGPControllerGetSigningKeyForDomain(domain: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PGPKeyDetails>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pGPControllerGetSigningKeyForDomain(domain, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PGPApi.pGPControllerGetSigningKeyForDomain']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pGPControllerGetSigningKeyForUser(email: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PGPKeyDetails>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pGPControllerGetSigningKeyForUser(email, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PGPApi.pGPControllerGetSigningKeyForUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {boolean} [ignoreParsingErrors] 
         * @param {string} [password] 
         * @param {File} [keyringFile] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pGPControllerImportKeyring(ignoreParsingErrors?: boolean, password?: string, keyringFile?: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pGPControllerImportKeyring(ignoreParsingErrors, password, keyringFile, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PGPApi.pGPControllerImportKeyring']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {string} userID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pGPControllerIsUserIDRevoked(id: string, userID: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pGPControllerIsUserIDRevoked(id, userID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PGPApi.pGPControllerIsUserIDRevoked']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {string} userID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pGPControllerIsUserIDValid(id: string, userID: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pGPControllerIsUserIDValid(id, userID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PGPApi.pGPControllerIsUserIDValid']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pGPControllerRevokeKey(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pGPControllerRevokeKey(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PGPApi.pGPControllerRevokeKey']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pGPControllerRevokeKeys(requestBody: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pGPControllerRevokeKeys(requestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PGPApi.pGPControllerRevokeKeys']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pGPControllerSetPGPKeyEmailAndDomains(id: string, requestBody: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pGPControllerSetPGPKeyEmailAndDomains(id, requestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PGPApi.pGPControllerSetPGPKeyEmailAndDomains']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} domain 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pGPControllerSetSigningKeyForDomain(domain: string, id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pGPControllerSetSigningKeyForDomain(domain, id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PGPApi.pGPControllerSetSigningKeyForDomain']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} email 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pGPControllerSetSigningKeyForUser(email: string, id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pGPControllerSetSigningKeyForUser(email, id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PGPApi.pGPControllerSetSigningKeyForUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PGPApi - factory interface
 * @export
 */
export const PGPApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PGPApiFp(configuration)
    return {
        /**
         * 
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pGPControllerExportPublicKeys(requestBody: Array<string>, options?: any): AxiosPromise<string> {
            return localVarFp.pGPControllerExportPublicKeys(requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ExportSecretKeysRequestBody} exportSecretKeysRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pGPControllerExportSecretKeys(exportSecretKeysRequestBody: ExportSecretKeysRequestBody, options?: any): AxiosPromise<string> {
            return localVarFp.pGPControllerExportSecretKeys(exportSecretKeysRequestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} email 
         * @param {string} name 
         * @param {PGPKeyGenerationType} [keyType] 
         * @param {boolean} [publishKeys] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pGPControllerGenerateSecretKeyRing(email: string, name: string, keyType?: PGPKeyGenerationType, publishKeys?: boolean, options?: any): AxiosPromise<GenerateSecretKeyRingDetails> {
            return localVarFp.pGPControllerGenerateSecretKeyRing(email, name, keyType, publishKeys, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} domain 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pGPControllerGetAvailableSigningKeysForDomain(domain: string, options?: any): AxiosPromise<Array<PGPKeyDetails>> {
            return localVarFp.pGPControllerGetAvailableSigningKeysForDomain(domain, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pGPControllerGetAvailableSigningKeysForEmail(email: string, options?: any): AxiosPromise<Array<PGPKeyDetails>> {
            return localVarFp.pGPControllerGetAvailableSigningKeysForEmail(email, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} domain 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pGPControllerGetEncryptionKeysForDomain(domain: string, options?: any): AxiosPromise<Array<PGPKeyDetails>> {
            return localVarFp.pGPControllerGetEncryptionKeysForDomain(domain, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pGPControllerGetEncryptionKeysForEmail(email: string, options?: any): AxiosPromise<Array<PGPKeyDetails>> {
            return localVarFp.pGPControllerGetEncryptionKeysForEmail(email, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} domain 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pGPControllerGetSigningKeyForDomain(domain: string, options?: any): AxiosPromise<PGPKeyDetails> {
            return localVarFp.pGPControllerGetSigningKeyForDomain(domain, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pGPControllerGetSigningKeyForUser(email: string, options?: any): AxiosPromise<PGPKeyDetails> {
            return localVarFp.pGPControllerGetSigningKeyForUser(email, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {boolean} [ignoreParsingErrors] 
         * @param {string} [password] 
         * @param {File} [keyringFile] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pGPControllerImportKeyring(ignoreParsingErrors?: boolean, password?: string, keyringFile?: File, options?: any): AxiosPromise<number> {
            return localVarFp.pGPControllerImportKeyring(ignoreParsingErrors, password, keyringFile, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {string} userID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pGPControllerIsUserIDRevoked(id: string, userID: string, options?: any): AxiosPromise<boolean> {
            return localVarFp.pGPControllerIsUserIDRevoked(id, userID, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {string} userID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pGPControllerIsUserIDValid(id: string, userID: string, options?: any): AxiosPromise<boolean> {
            return localVarFp.pGPControllerIsUserIDValid(id, userID, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pGPControllerRevokeKey(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.pGPControllerRevokeKey(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pGPControllerRevokeKeys(requestBody: Array<string>, options?: any): AxiosPromise<void> {
            return localVarFp.pGPControllerRevokeKeys(requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pGPControllerSetPGPKeyEmailAndDomains(id: string, requestBody: Array<string>, options?: any): AxiosPromise<void> {
            return localVarFp.pGPControllerSetPGPKeyEmailAndDomains(id, requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} domain 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pGPControllerSetSigningKeyForDomain(domain: string, id: string, options?: any): AxiosPromise<void> {
            return localVarFp.pGPControllerSetSigningKeyForDomain(domain, id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} email 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pGPControllerSetSigningKeyForUser(email: string, id: string, options?: any): AxiosPromise<void> {
            return localVarFp.pGPControllerSetSigningKeyForUser(email, id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PGPApi - object-oriented interface
 * @export
 * @class PGPApi
 * @extends {BaseAPI}
 */
export class PGPApi extends BaseAPI {
    /**
     * 
     * @param {Array<string>} requestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PGPApi
     */
    public pGPControllerExportPublicKeys(requestBody: Array<string>, options?: RawAxiosRequestConfig) {
        return PGPApiFp(this.configuration).pGPControllerExportPublicKeys(requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ExportSecretKeysRequestBody} exportSecretKeysRequestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PGPApi
     */
    public pGPControllerExportSecretKeys(exportSecretKeysRequestBody: ExportSecretKeysRequestBody, options?: RawAxiosRequestConfig) {
        return PGPApiFp(this.configuration).pGPControllerExportSecretKeys(exportSecretKeysRequestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} email 
     * @param {string} name 
     * @param {PGPKeyGenerationType} [keyType] 
     * @param {boolean} [publishKeys] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PGPApi
     */
    public pGPControllerGenerateSecretKeyRing(email: string, name: string, keyType?: PGPKeyGenerationType, publishKeys?: boolean, options?: RawAxiosRequestConfig) {
        return PGPApiFp(this.configuration).pGPControllerGenerateSecretKeyRing(email, name, keyType, publishKeys, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} domain 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PGPApi
     */
    public pGPControllerGetAvailableSigningKeysForDomain(domain: string, options?: RawAxiosRequestConfig) {
        return PGPApiFp(this.configuration).pGPControllerGetAvailableSigningKeysForDomain(domain, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} email 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PGPApi
     */
    public pGPControllerGetAvailableSigningKeysForEmail(email: string, options?: RawAxiosRequestConfig) {
        return PGPApiFp(this.configuration).pGPControllerGetAvailableSigningKeysForEmail(email, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} domain 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PGPApi
     */
    public pGPControllerGetEncryptionKeysForDomain(domain: string, options?: RawAxiosRequestConfig) {
        return PGPApiFp(this.configuration).pGPControllerGetEncryptionKeysForDomain(domain, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} email 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PGPApi
     */
    public pGPControllerGetEncryptionKeysForEmail(email: string, options?: RawAxiosRequestConfig) {
        return PGPApiFp(this.configuration).pGPControllerGetEncryptionKeysForEmail(email, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} domain 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PGPApi
     */
    public pGPControllerGetSigningKeyForDomain(domain: string, options?: RawAxiosRequestConfig) {
        return PGPApiFp(this.configuration).pGPControllerGetSigningKeyForDomain(domain, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} email 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PGPApi
     */
    public pGPControllerGetSigningKeyForUser(email: string, options?: RawAxiosRequestConfig) {
        return PGPApiFp(this.configuration).pGPControllerGetSigningKeyForUser(email, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {boolean} [ignoreParsingErrors] 
     * @param {string} [password] 
     * @param {File} [keyringFile] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PGPApi
     */
    public pGPControllerImportKeyring(ignoreParsingErrors?: boolean, password?: string, keyringFile?: File, options?: RawAxiosRequestConfig) {
        return PGPApiFp(this.configuration).pGPControllerImportKeyring(ignoreParsingErrors, password, keyringFile, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {string} userID 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PGPApi
     */
    public pGPControllerIsUserIDRevoked(id: string, userID: string, options?: RawAxiosRequestConfig) {
        return PGPApiFp(this.configuration).pGPControllerIsUserIDRevoked(id, userID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {string} userID 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PGPApi
     */
    public pGPControllerIsUserIDValid(id: string, userID: string, options?: RawAxiosRequestConfig) {
        return PGPApiFp(this.configuration).pGPControllerIsUserIDValid(id, userID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PGPApi
     */
    public pGPControllerRevokeKey(id: string, options?: RawAxiosRequestConfig) {
        return PGPApiFp(this.configuration).pGPControllerRevokeKey(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<string>} requestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PGPApi
     */
    public pGPControllerRevokeKeys(requestBody: Array<string>, options?: RawAxiosRequestConfig) {
        return PGPApiFp(this.configuration).pGPControllerRevokeKeys(requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {Array<string>} requestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PGPApi
     */
    public pGPControllerSetPGPKeyEmailAndDomains(id: string, requestBody: Array<string>, options?: RawAxiosRequestConfig) {
        return PGPApiFp(this.configuration).pGPControllerSetPGPKeyEmailAndDomains(id, requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} domain 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PGPApi
     */
    public pGPControllerSetSigningKeyForDomain(domain: string, id: string, options?: RawAxiosRequestConfig) {
        return PGPApiFp(this.configuration).pGPControllerSetSigningKeyForDomain(domain, id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} email 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PGPApi
     */
    public pGPControllerSetSigningKeyForUser(email: string, id: string, options?: RawAxiosRequestConfig) {
        return PGPApiFp(this.configuration).pGPControllerSetSigningKeyForUser(email, id, options).then((request) => request(this.axios, this.basePath));
    }
}

